import { render, staticRenderFns } from "./AdminTabsLayers.vue?vue&type=template&id=36e406fe&scoped=true&"
import script from "./AdminTabsLayers.vue?vue&type=script&lang=js&"
export * from "./AdminTabsLayers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e406fe",
  null
  
)

export default component.exports